import { useState } from "react";
import { auth, db, storage } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid"; // Unique filenames
import { useDropzone } from "react-dropzone";

const AddListing = () => {
  const [newListing, setNewListing] = useState({
    title: "",
    price: "",
    location: "",
    description: "",
    category: "",
    category2: "",
    condition: "new",
    campaignId: "",
    photos: [],
  });

  const [imageFiles, setImageFiles] = useState([]); // Stores image file objects

  // ✅ Drag-and-Drop Image Upload
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: true,
    onDrop: (acceptedFiles) => {
      setImageFiles([...imageFiles, ...acceptedFiles]); // Append new images
    },
  });

  // ✅ Remove an Image from Preview
  const removeImage = (index) => {
    setImageFiles(imageFiles.filter((_, i) => i !== index));
  };

  // ✅ Reorder Images (Drag & Drop)
  const handleImageReorder = (dragIndex, hoverIndex) => {
    const draggedImage = imageFiles[dragIndex];
    const updatedFiles = [...imageFiles];
    updatedFiles.splice(dragIndex, 1);
    updatedFiles.splice(hoverIndex, 0, draggedImage);
    setImageFiles(updatedFiles);
  };

  // ✅ Upload Images & Create Listing
  const handleCreateListing = async () => {
    if (!newListing.title || !newListing.price || !newListing.location || !newListing.category || !newListing.category2) {
      alert("Please fill all required fields.");
      return;
    }

    try {
      // Upload images to Firebase Storage
      const uploadedImageURLs = [];
      for (const file of imageFiles) {
        const storageRef = ref(storage, `listings/${uuidv4()}-${file.name}`);
        await uploadBytes(storageRef, file);
        const fileURL = await getDownloadURL(storageRef);
        uploadedImageURLs.push(fileURL);
      }

      // Add listing to Firestore
      const docRef = await addDoc(collection(db, "listings"), {
        ...newListing,
        userId: auth.currentUser.uid,
        photos: uploadedImageURLs, // Store all image URLs
      });

      // Reset form
      setNewListing({
        title: "",
        price: "",
        location: "",
        description: "",
        category: "Furniture",
        category2: "Mattresses",
        condition: "new",
        campaignId: "",
        photos: [],
      });
      setImageFiles([]);

      alert("Listing created successfully!");
    } catch (error) {
      console.error("Error creating listing:", error);
      alert("Failed to create listing.");
    }
  };

  return (
    <div className="add-listing-container">
      <h2>Add New Listing</h2>

      <input type="text" placeholder="Title" value={newListing.title} onChange={(e) => setNewListing({ ...newListing, title: e.target.value })} required />
      <input type="number" placeholder="Price" value={newListing.price} onChange={(e) => setNewListing({ ...newListing, price: e.target.value })} required />
      <input type="text" placeholder="Location (City, State)" value={newListing.location} onChange={(e) => setNewListing({ ...newListing, location: e.target.value })} required />
      <textarea placeholder="Description" value={newListing.description} onChange={(e) => setNewListing({ ...newListing, description: e.target.value })} required></textarea>

      <select value={newListing.category || "Furniture"} onChange={(e) => setNewListing({ ...newListing, category: e.target.value })} required>
        <option value="" disabled hidden>Select Category</option>
        <option value="Furniture">Furniture</option>
        <option value="Electronics">Electronics</option>
      </select>

      <select value={newListing.category2 || "Mattresses"} onChange={(e) => setNewListing({ ...newListing, category2: e.target.value })} required>
        <option value="" disabled hidden>Select Secondary Category</option>
        <option value="Mattresses">Mattresses</option>
        <option value="Office">Office</option>
        <option value="Home">Home</option>
      </select>

      <select value={newListing.condition} onChange={(e) => setNewListing({ ...newListing, condition: e.target.value })} required>
        <option value="new">New</option>
        <option value="used">Used</option>
      </select>

      {/* ✅ Drag & Drop Image Upload */}
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        <p>Drag & Drop images here or click to select files.</p>
      </div>

      {/* ✅ Image Preview & Reordering */}
      <div className="image-preview">
        {imageFiles.map((file, index) => (
          <div key={index} className="image-thumbnail">
            <img src={URL.createObjectURL(file)} alt="Preview" />
            <button onClick={() => removeImage(index)}>❌</button>
          </div>
        ))}
      </div>

      <button onClick={handleCreateListing}>Create Listing</button>
    </div>
  );
};

export default AddListing;
